import watchApp from './app';
import homepage from './homepage';
import carList from './car-list';
import login from './login';
import carDetail from './car-detail';
import certification from './certification';

export default [
  ...watchApp,
  ...homepage,
  ...carList,
  ...login,
  ...carDetail,
  ...certification,
];
